import { render } from "./ItemList.vue?vue&type=template&id=771e4f1b"
import script from "./ItemList.vue?vue&type=script&lang=js"
export * from "./ItemList.vue?vue&type=script&lang=js"

import "./ItemList.vue?vue&type=style&index=0&id=771e4f1b&lang=css"
script.render = render

export default script